export default __webpack_public_path__ + "static/media/obs_step5.cdad0a7a.png";